import { render, staticRenderFns } from "./PrestamosPrendarios.vue?vue&type=template&id=768248f5"
import script from "./PrestamosPrendarios.vue?vue&type=script&lang=js"
export * from "./PrestamosPrendarios.vue?vue&type=script&lang=js"
import style0 from "./PrestamosPrendarios.vue?vue&type=style&index=0&id=768248f5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports